<template>
  <div class="h-dialogContainer">
    <div class="dp-left-width" style="overflow-x: hidden;">
      <div style="height:100%;">
        <div class="left-box">
          <div class="left-logo">
            <span class="word-front">{{sendServiceName}}</span>
            <span class="word-behind">{{sendServiceName}}</span>
          </div>

          <div class="left-word">
            <span class="left-wordName">{{$t('NSMF.nsmfAppIntroduction')}}</span>
            <span class="left-wordContent">{{packageList.description}}</span>
          </div>
          <div class="left-word">
            <span class="left-wordName">{{$t('NSMF.nsmfDeliveryType')}}</span>
            <span class="left-wordContent">{{deliverType}}</span>
          </div>
          <div class="left-word">
            <span class="left-wordName">{{$t('NSMF.nsmfShelfTime')}}</span>
            <span class="left-wordContent">{{createTime}}</span>
          </div>
          <div class="left-word">
            <span class="left-wordName">{{$t('NSMF.nsmfVersionNum')}}</span>
            <span class="left-wordContent">{{packageList.version}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="dp-right-width" style="padding-left: 20px;">
      <div v-show="upfAliasShow">
      <DeployCaseInput ref='deployCaseInput' :oamTypeCode='oamTypeCodeParent'></DeployCaseInput>      
      </div>

      <div class="fl h-mml-dldInput">
        <template>
          <div v-for="(item, index) in sourceData" :key="index">
            <div class="h-borderBox h-subscriber-parseList h-dp-deploy-style">
              <div class="h-dialog-borderBox-topIcon">
                {{item.description}}
                <div class="h-toolbarBg dialog-icon-style">
                  <ejs-toolbar class="dialog-icon-style">
                    <div class="dialog-icon-style"></div>
                  </ejs-toolbar>
                </div>
              </div>
              <div class="h-borderBox-content" style="overflow: hidden">
                <div
                  class="h-subscriber-listArr h-subscriber-listParseForm"
                  style="border:none;margin-left:0;padding: 0 20px;width:100%;"
                >
                  <div v-for="(item2, index2) in dataByGroup.get(item.key)" :key="index2">
                    <div v-for="(item3,index3) in item2.slice(1)" :key="index3">
                      <div class="h-dialog-borderBox-topIcon" style="background:#f7f7f7">
                        {{item2[0]}}
                        <div class="h-toolbarBg dialog-icon-style">
                          <ejs-toolbar class="dialog-icon-style">
                            <div class="dialog-icon-style"></div>
                          </ejs-toolbar>
                        </div>
                      </div>
                      <div class="h-dp-deploy-style">
                        <ParseForm
                          :ref="item.key"
                          :formId="item.key"
                          :formParams="item3"
                          :opCode="parseOpCode"
                        ></ParseForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ParseForm from "../../subscriberconfig/util/parseFormNew/ParseForm";
import SubscriberTool from "../../subscriberconfig/util/parseFormNew/tools/subscriberTool";
import ajaxUrl from "../../subscriberconfig/data/ajaxUrl";
import { EventBus } from "../../../plugins/eventBus";
import { FormValidator } from "@syncfusion/ej2-vue-inputs";
import DeployCaseInput from "./deployCaseInput";

export default {
  name: "deployCaseDialogNsmf",
  components: {
    ParseForm,DeployCaseInput
  },
  props: ['oamTypeCodeParent'],
  data() {
    return {
      opCode: "add",
      sourceData: [],
      upfNodeNameIp: [],
      dataByGroup: new Map(),
      environment: 0,
      alias: "",
      description: "",
      chartPath: "",
      pkgVersion: "",
      deliverType: "",
      createTime: "",
      oamTypeCode: "",
      configPath: "",
      methodList: {},
      packageList: {},
      instanId: "",
      sendServiceName: "",
      methodMap: new Map(),
      formObj: "",
      namespace:"default",
      optionName:'',
      ip:'',
      upfAliasShow:true,
    };
  },
  methods: {
    async onMethodChange() {
      if (this.environment !== null) {
        const chooseId = this.environment;
        for (let i = 0; i < this.sourceData.length; i++) {
          for (let j = 0; j < this.sourceData[i].resultVal.length; j++) {
            //数据检测有meyhod的调用后台
            if (this.sourceData[i].resultVal[j].method) {
              let option = [];
              const methodName = this.sourceData[i].resultVal[j].method;
              const url = this.methodList[methodName] + "?envid=" + chooseId;
              await this.$axios.get(url).then(response => {
                  for (var k = 0; k < response.data.resultVal.length; k++) {
                    if (undefined === response.data.resultVal[k].showField) {
                      //目前tolerations污点特殊处理
                      //options赋值
                      let valueOption = { showName: "", value: "" };
                      valueOption.showName = response.data.resultVal[k].key;
                      valueOption.value = k;
                      option.push(valueOption);
                      this.methodMap.set(
                        this.sourceData[i].resultVal[j].name + "-" + k,
                        response.data.resultVal[k]
                      );
                      //全局变量组装
                    } //给的格式不是showfield,shi key ,value
                    else {
                      //options赋值
                      this.upfNodeNameIp=response.data.resultVal;//upf特殊处理选几个节点填写几个名称
                      let valueOption = { showName: "", value: "" };
                      valueOption.showName =
                        response.data.resultVal[k].showField;
                      valueOption.value = k;
                      option.push(valueOption);
                      let mapValue = {};
                      mapValue[response.data.resultVal[k].labelKey] =
                        response.data.resultVal[k].labelValue;
                      this.methodMap.set(
                        this.sourceData[i].resultVal[j].name + "-" + k,
                        mapValue
                      ); //全局变量组装
                    }
                  }
                  this.methodMap.set(
                    this.sourceData[i].resultVal[j].name,
                    response.data.resultVal.length
                  );
                  if(undefined!==option[0]&&null!==option[0].showName&&""!==option[0].showName){//污点为空的时候
                  this.$set(this.sourceData[i].resultVal[j], "options", option);} //增加新属性
                });
            }
          }
        }
      }
    },
    clear(){
     this.sourceData=[];
     this.upfNodeNameIp=[];
    },
    getDatas() {
      const map = new Map();
      for (var i = 0; i < this.sourceData.length; i++) {
        const key = this.sourceData[i].key;
        if (undefined !== this.$refs[`${key}`]) {
          for (var j = 0; j < this.$refs[`${key}`].length; j++) {
            if (this.$refs[`${key}`][j]) {
              if (!this.$refs[`${key}`][j].validateResult()) {
                console.log("表单验证不通过");
                return false;
              }
              const maps = this.$refs[`${key}`][j].getDatas();
              for (const [key, value] of maps.entries()) {
                map.set(key, value);
              }
            }
          }
        }
      }
      return map;
    },
    getJson(detailInfo, callback) {
      this.$refs.deployCaseInput.init(detailInfo.optionName);//由于AMF多个部署，oamtypecode不再唯一，所以detailInfo.oamTypeCode换成detailInfo.optionName
      this.chartPath = detailInfo.chartPath;
      this.configPath = detailInfo.configPath;
      this.pkgVersion = detailInfo.pkgVersion;
      this.deliverType = detailInfo.deliverType;
      this.createTime = detailInfo.createTime;
      this.oamTypeCode = detailInfo.oamTypeCode;
      this.sendServiceName = detailInfo.serviceName;
      this.optionName=detailInfo.optionName;//传过来的网元类型

      let locale = this._i18n.locale;
      if (locale === "zh") {
        locale = "zh_CN";
      } else {
        locale = "en_US";
      }
      //环境数据
      // this.getEnvItems();
      //产品侧获取json数据
      const paramGetJson = {
        info: {
          processName: "ems_mano",
          path: this.configPath,
          i18n: locale
        }
      };
      this.$axios
        .post("/lte/ems/nf/getParamJson", paramGetJson)
        .then(response => {
          const res = response.data.resultVal; //实际数据
          var str1 = JSON.parse(res);
          this.sourceData = str1.vo;
          this.methodList = str1.info.method;
          this.packageList = str1.info.package;
          this.instanId = str1.info.insId;
          const sub = new SubscriberTool();
          for (var i = 0; i < this.sourceData.length; i++) {
            const dataValue = sub.$devideByGroupBy(
              this.sourceData[i].resultVal,
              []
            );
            //按groupBy分数据
            this.dataByGroup.set(this.sourceData[i].key, dataValue);
            for (var j = 0; j < this.sourceData[i].resultVal.length; j++) {
              //upf类型定制，节点选择从radio改为checkbox
              if(this.optionName==41&&this.sourceData[i].resultVal[j].name=="Values.nodeSelector"){
               this.sourceData[i].resultVal[j].type="upfcheckbox"
               this.upfAliasShow=false;//屏蔽upf的别名
              }
              if(this.optionName==41&&this.sourceData[i].resultVal[j].name=="Values.selectIP"){//屏蔽UPF的ip
               this.sourceData[i].resultVal[j].hidden=true
              }
              this.sourceData[i].resultVal[j].name =this.sourceData[i].key +this.sourceData[i].resultVal[j].name + this.sourceData[i].resultVal[j].uiIndex+this.optionName;
            }
          }
          this.onMethodChange();
        });
    },
    checkGetTemplateJson(){
      const deployCaseInput = this.$refs.deployCaseInput.getDeployCaseInput();
      console.log("deployCaseInput",deployCaseInput)
      if (!deployCaseInput) {//校验别名是否填写
        return false;
      }
      const formData = this.getDatas();//校验具体不是信息是否校验通过
      return formData;
    },

    getTemplateJson() {
      let label = ""; //产品json自带
      const formData = this.checkGetTemplateJson();
      console.log("formData getTemplateJson",formData)
      if (formData) {
        let aliasUpf="";
        let ipUpf="";
        let deployCaseInput = this.$refs.deployCaseInput.getDeployCaseInput()
        for (let i = 0; i < this.sourceData.length; i++) {
          for (let j = 0; j < this.sourceData[i].resultVal.length; j++) {
            let resultValEvery = this.sourceData[i].resultVal[j];
            let sourceName = resultValEvery.name;
            let idValue = formData.get(sourceName);
            if ((resultValEvery.method !== undefined)) {
              if (resultValEvery.type !== "radio") {//目前此种情况为checkbox
                if(resultValEvery.type=="upfcheckbox"){//upf定制,从组件内将拼接的值拆分格式为“CheckBox值：别名值：IP值”
                  const upfCheckboxDataAll=idValue;
                  const checkboxUpfValue=upfCheckboxDataAll.split(":")[0];
                  aliasUpf=upfCheckboxDataAll.split(":")[1];
                  ipUpf=upfCheckboxDataAll.split(":")[2];
                  deployCaseInput.alias=aliasUpf+":"+ipUpf;//到父组件取值时再拆分新拼接的别名和IP
                  idValue=checkboxUpfValue;
                }
                let methodData = [];
                let bitValue = parseInt(idValue).toString(2); //转成2进制
                if(bitValue==0){//如果upf的节点checkbox未选择，校验是必填
                 EventBus.$emit("toast", {type: "warning",content: this.$t("NSMF.nok8sNode")});//未勾选节点
                 return false;
                 }
                let bitValueSize = bitValue.length; //2进制长度
                let countCheckboxAll = this.methodMap.get(sourceName); //每组有method的checkbox的选项总个数
                if (bitValueSize < countCheckboxAll) {
                  //补全位数 0000，这里我要显示n位
                  for (let z = 0; z < countCheckboxAll - bitValueSize; z++) {
                    bitValue = "0" + bitValue; //不够的就在前面补0
                  }
                }
                bitValue = bitValue.split("").reverse().join("");
                for (let k = 0; k < countCheckboxAll; k++) {
                  //判断1的位置
                  if (bitValue[k] === "1") {
                    let keyEvery = sourceName + "-" + k;
                    let valueEvery = this.methodMap.get(keyEvery);
                    methodData.push(valueEvery);
                  }
                }
                resultValEvery.value = methodData; //表单数据付给value
              } else if (resultValEvery.type === "radio") {
                let methodData = [];
                let keyEvery = sourceName + "-" + idValue;
                let valueEvery = this.methodMap.get(keyEvery);
                methodData.push(valueEvery);
                resultValEvery.value = methodData; //表单数据付给value

              }
            } else {
              resultValEvery.value = idValue; //表单数据付给value
            }
            resultValEvery.name = resultValEvery.id; //name变回原值
            if(this.optionName==41&&resultValEvery.name=="Values.nodeSelector"){//41UPF special deal
               resultValEvery.type="radio";
              }
            if(this.optionName==41&&resultValEvery.name=="Values.selectIP"){//41UPF special deal
               resultValEvery.value=ipUpf;
               resultValEvery.hidden=false;
              }
          }
        }
        console.log("this.sourceData",this.sourceData)
        return {
          vo: this.sourceData,
          info: {
            processName: "ems_mano",
            ip: this.ip,
            alias: deployCaseInput.alias, //别名用户自定义
            serviceName: this.instanId, //实例名称
            id: this.environment,
            method: this.methodList,
            chart_url: this.chartPath,
            path: this.configPath,
            pkgVersion: this.pkgVersion,
            description: deployCaseInput.description,
            oamTypeCode: this.oamTypeCode,
            namespace: this.namespace,
          }
        };
      }
    },
  },

 
  created() {
    EventBus.$on('environmentParam', target => {
      this.environment = target.environmentParent;
      this.ip = target.envIp;
    });
  },
  computed: {
    parseOpCode() {
      return this.opCode + "";
    }
  }
};
</script>
<style scoped>
.left-box {
  height: 100%;
  width: 240px;
  background: #fff;
  border: 1px solid #eee;
  position: relative;
}
.left-logo {
  height: 92px;
  width: 100%;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
  background: url(../../../assets/images/logoAmf.png) no-repeat 0 0;
}
.word-front {
  font-size: 42px;
  position: absolute;
  height: 92px;
  width: 100%;
  left: 0;
  top: 0;
  padding-top: 12px;
  color: #1890ff;
  text-align: center;
  z-index: 999;
}
.word-behind {
  font-size: 42px;
  position: absolute;
  height: 92px;
  width: 100%;
  left: 0;
  top: 0;
  padding-top: 15px;
  text-align: center;
  color: #d9f0ff;
  text-indent: 3px;
}
.left-word {
  width: 100%;
  margin: 10px 0;
  float: left;
}
.left-wordName {
  font-size: 12px;
  color: #ccc;
  width: 100%;
  float: left;
  text-indent: 15px;
}
.left-wordContent {
  font-size: 14px;
  color: #333;
  width: 100%;
  float: left;
  text-indent: 15px;
}
.h-dialogContainer{
  height:100%;
}
</style>
